
import {
  Typography, Paper, Avatar, IconButton, Card, CardContent, CardActions, Box, Grid
} from '@mui/material';
import { Edit as EditIcon, DeleteOutline as DeleteOutlineIcon } from '@mui/icons-material';
import { User } from '../../../core/interfaces/user.interface';
import RoleChip from '../RoleChip';

interface UserCardProps {
  user: User;
  onEdit: () => void;
  onDelete: () => void;
}


export default function UserCard({ user, onEdit, onDelete }: UserCardProps) {
  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      {/* Añadimos efectos de transición y sombra al pasar el cursor */}
      <Card
        variant="outlined"
        className="h-full flex flex-col transition-all duration-300 ease-in-out hover:shadow-xl hover:-translate-y-1"
      >
        <CardContent className="flex flex-col items-center text-center flex-grow p-6">
          {/* Anillo de estado alrededor del avatar */}
          <Box className="relative">
            <Avatar
              src={user.avatar || ''}
              alt={user.full_name}
              sx={{ width: 96, height: 96, fontSize: '2.5rem' }}
            >
              {user.full_name.charAt(0).toUpperCase()}
            </Avatar>
            <Box
              className={`absolute bottom-0 right-0 w-6 h-6 rounded-full border-2 border-white dark:border-gray-800 ${
                user.active ? 'bg-green-500' : 'bg-gray-400'
              }`}
            />
          </Box>
          
          <Typography variant="h6" className="font-semibold mt-4 truncate w-full">
            {user.full_name}
          </Typography>
          <Typography color="text.secondary" variant="body2" className="truncate w-full">
            {user.email}
          </Typography>
          
          <Box className="mt-2">
            <RoleChip isSuperuser={user.is_superuser} role={user.role} />
          </Box>
        </CardContent>
        <CardActions
          sx={{
            justifyContent: 'center',
            borderTop: 1,
            borderColor: 'divider',
            bgcolor: 'action.hover' // Un fondo sutil para el área de acciones
          }}
        >
          <IconButton onClick={onEdit} color="primary" title="Editar usuario">
            <EditIcon />
          </IconButton>
          <IconButton onClick={onDelete} color="error" title="Eliminar usuario">
            <DeleteOutlineIcon />
          </IconButton>
        </CardActions>
      </Card>
    </Grid>
  );
}
